import { FC } from 'react';
import { ConfigProvider as AntdConfigProvider, ConfigProviderProps } from 'antd';

import { COLORS } from '@/shared/constants/colors';

export const ConfigProvider: FC<ConfigProviderProps> = (props) => {
  return (
    <AntdConfigProvider
      theme={{
        components: {
          Table: {
            rowSelectedBg: 'transparent',
            rowSelectedHoverBg: COLORS.systemLight200,
            // headerSortHoverBg: COLORS.systemLight200,
          },
        },
      }}
      {...props}
    />
  );
};
